import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from 'react';
import { useAsync } from '../../behaviors/async';
import TypeaheadComponent from '../Typeahead';
var AsyncTypeahead = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(TypeaheadComponent, _extends({}, useAsync(props), {
    ref: ref
  }));
});
export default AsyncTypeahead;